import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';

import 'react-widgets/dist/css/react-widgets.css';
import { DropdownList } from 'react-widgets';

import Modal from '../components/Modal';
import { schools } from '../variables/schoolList';
import regiones from '../variables/regiones.json';
import comunas from '../variables/comunas.json';
import colegios from '../variables/colegios.json';
import carreras from '../variables/carreras.json';

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      pass: '',
      user: JSON.parse(localStorage.getItem('tpuser')),
      suggestions: [],
      reg_school_region: '',
      reg_school_comuna: '',
      reg_school: '',
      reg_grade: '',
      error: false,
      modal: false,
      filtering: false,
      reg_email: '',
      reg_rut: '',
      reg_dv: '',
      reg_mobile: '',
      reg_ciudad: '',
      reg_carrera1: '',
      reg_carrera2: '',
      reg_carrera3: '',
      reg_tyc: false,
      carreras: carreras,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleChangeReg = this.handleChangeReg.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmitReg = this.handleSubmitReg.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.resetPass = this.resetPass.bind(this);

    //console.log(process.env);
  }

  // componentDidMount() {}

  // RUT
  dv = (T) => {
    var M = 0,
      S = 1;
    for (; T; T = Math.floor(T / 10)) S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
    return S ? S - 1 : 'k';
  };
  validaRut = (rutCompleto) => {
    if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto)) return false;
    var tmp = rutCompleto.split('-');
    var digv = tmp[1];
    var rut = tmp[0];
    if (digv == 'K') digv = 'k';
    return this.dv(rut) == digv;
  };

  // Teach Autosuggest how to calculate suggestions for any given input value.
  getSuggestions = (value) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    let cont = 0;
    return inputLength < 5
      ? []
      : schools.filter((school, si) => {
          cont++;
          return (
            school.text.toLowerCase().slice(0, inputLength) === inputValue &&
            cont < 11
          );
        });
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({ suggestions: this.getSuggestions(value) });
  };

  renderSuggestion = (suggestion) => <div>{suggestion.text}</div>;

  handleChange(event) {
    const name = event.target.name;
    this.setState({ [name]: event.target.value });
  }

  handleChangeReg(event) {
    // console.log(event);
    const name = event.target.name;
    const value =
      event.target.type == 'checkbox'
        ? event.target.checked
        : event.target.value;
    // console.log({ [name]: value }, event.target.type);
    this.setState({ [name]: value });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.apiLogin();
  }

  handleSubmitReg(event) {
    event.preventDefault();
    if (!this.state.reg_email || !this.state.reg_email.match(/^\S+@\S+\.\S+$/))
      return alert('Debes ingresar un correo electrónico válido.');

    // School & Locations
    if (!this.state.reg_school.length)
      return alert('Debes seleccionar tu establecimiento educacional.');
    if (!this.state.reg_school_region.length)
      return alert(
        'Debes seleccionar la región de tu establecimiento educacional.'
      );
    if (!this.state.reg_school_comuna.length)
      return alert(
        'Debes seleccionar la comuna de tu establecimiento educacional.'
      );

    if (!this.state.reg_ciudad)
      return alert('Debes seleccionar la ciudad donde quieres estudiar.');
    if (!this.state.reg_carrera1)
      return alert('Debes seleccionar tu primera preferencia de carrera.');

    if (!this.state.reg_rut.length) return alert('Debes ingresar tu RUT.');
    if (!this.state.reg_grade) return alert('Debes seleccionar tu curso.');
    if (!this.validaRut(this.state.reg_rut + '-' + this.state.reg_dv))
      return alert('Debes ingresas un RUT válido.');
    if (!this.state.reg_mobile.length)
      return alert('Debes ingresar tu número telefónico.');
    if (this.state.reg_mobile.length !== 12)
      return alert('Ingresa tu número con este formato: +569XXXXXXXX');
    if (!this.state.reg_tyc)
      return alert('Debes aceptar los Términos y Condiciones.');
    this.apiReg();
  }

  resetPass(e) {
    e.preventDefault();
    const { email } = this.state;
    if (email.length === 0) {
      this.setState({ error: 'Debes ingresar tu email.' });
    } else {
      let self = this;
      fetch(process.env.REACT_APP_API_URL + '/auth/reset', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: this.state.email,
        }),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          if (data.email) {
            self.setState({
              error: 'Te hemos enviado un email con tu nueva contraseña.',
            });
          } else {
            self.setState({
              error: 'No hemos podido reestablecer tu contraseña.',
            });
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    }
  }

  apiLogin() {
    let self = this;
    fetch(process.env.REACT_APP_API_URL + '/auth/login', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: this.state.email,
        password: this.state.pass,
      }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.token) {
          localStorage.setItem('tpuser', JSON.stringify(data));
          self.setState({ user: data });
        } else {
          self.setState({ error: 'Credenciales incorrectas' });
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  }

  apiReg() {
    let self = this;
    fetch(process.env.REACT_APP_API_URL + '/auth/register', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: this.state.reg_name,
        lastname: this.state.reg_lastname,
        lastname_mat: this.state.reg_lastname_mat,
        email: this.state.reg_email,
        rut: this.state.reg_rut,
        dv: this.state.reg_dv,
        sex: this.state.reg_sex,
        school: this.state.reg_school,
        school_region: this.state.reg_school_region,
        school_comuna: this.state.reg_school_comuna,
        grade: this.state.reg_grade,
        mobile: this.state.reg_mobile,
        ciudad: this.state.reg_ciudad,
        carrera1: this.state.reg_carrera1,
        // carrera2: this.state.reg_carrera2,
        // carrera3: this.state.reg_carrera3,
        password: this.state.reg_pass,
      }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.token) {
          localStorage.setItem('tpuser', JSON.stringify(data));
          self.setState({ user: data });
          window.dataLayer.push({ event: 'RegistroExitoso' });
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  }

  toggleModal() {
    this.setState({ modal: !this.state.modal });
  }

  render() {
    const { reg_ciudad, carreras } = this.state;

    if (
      this.state.user != null &&
      this.state.user.token &&
      this.state.user.token.length > 0
    )
      return <Redirect to='/test' />;
    const alert = this.state.error ? (
      <div style={{ marginBottom: '15px' }}>
        <span className='red'>{this.state.error}</span>
      </div>
    ) : (
      ''
    );

    // // Autosuggest will pass through all these props to the input.
    // const inputProps = {
    //   placeholder: 'Ingresa tu establecimiento...',
    //   name: 'reg_school',
    //   value: this.state.reg_school,
    //   onChange: this.handleChangeReg
    // };

    const carrerasOps = carreras[reg_ciudad]
      ? carreras[reg_ciudad].map((c) => {
          return (
            <option key={`carr-${c.id}`} value={c.id}>
              {c.name}
            </option>
          );
        })
      : [];

    // console.log(this.state);

    return (
      <div className='container margin-top-100'>
        <div className='row text-center'>
          <div className='col-sm-12 col-md-4 offset-md-1'>
            <h2 className='upper title pull-left margin-bot-20'>Ingresa</h2>

            {alert}

            <div className='form-row'>
              <div className='form-group col'>
                <input
                  className='form-control form-control'
                  name='email'
                  onChange={this.handleChange}
                  placeholder='Correo electronico'
                />
              </div>
            </div>

            <div className='form-row'>
              <div className='form-group col'>
                <input
                  className='form-control form-control'
                  name='pass'
                  onChange={this.handleChange}
                  type='password'
                  placeholder='Contraseña'
                />
              </div>
            </div>

            {/* <h6 className="pass margin-bot-20">¿Olvidaste la contraseña?</h6> */}

            <button
              className='btn btn-lg btn-black margin-top-20 margin-bot-20'
              onClick={this.handleSubmit}>
              Ingresar
            </button>

            <br />

            <button className='btn btn-link text-dark' onClick={this.resetPass}>
              Recuperar contraseña
            </button>
          </div>

          <div className='col-sm-12 col-md-5 offset-md-1'>
            <h2 className='upper title pull-left margin-bot-20'>Registrate</h2>

            <div className='form-row'>
              <div className='form-group col'>
                <input
                  className='form-control form-control'
                  name='reg_name'
                  onChange={this.handleChangeReg}
                  placeholder='Nombre'
                />
              </div>
            </div>

            <div className='form-row'>
              <div className='form-group col'>
                <input
                  className='form-control form-control'
                  name='reg_lastname'
                  onChange={this.handleChangeReg}
                  placeholder='Apellido Paterno'
                />
              </div>
              <div className='form-group col'>
                <input
                  className='form-control form-control'
                  name='reg_lastname_mat'
                  onChange={this.handleChangeReg}
                  placeholder='Apellido Materno'
                />
              </div>
            </div>

            <div className='form-row'>
              <div className='form-group col'>
                <input
                  className='form-control form-control'
                  name='reg_rut'
                  onChange={this.handleChangeReg}
                  placeholder='RUT (sin puntos)'
                />
              </div>
              <div className='form-group col-1'>-</div>
              <div className='form-group col-4'>
                <input
                  className='form-control form-control'
                  name='reg_dv'
                  onChange={this.handleChangeReg}
                  placeholder='Dígito Verificador'
                />
              </div>
            </div>

            <div className='form-row'>
              <div className='form-group col'>
                <input
                  className='form-control form-control'
                  type='email'
                  name='reg_email'
                  onChange={this.handleChangeReg}
                  placeholder='Email'
                />
              </div>
            </div>

            <div className='form-row'>
              <div className='form-group col'>
                <input
                  className='form-control form-control'
                  name='reg_mobile'
                  onChange={this.handleChangeReg}
                  placeholder='Celular: +569XXXXXXXX'
                />
              </div>
              <div className='form-group col'>
                <select
                  className='form-control form-control'
                  name='reg_sex'
                  onChange={this.handleChangeReg}>
                  <option value=''>Selecciona tu género</option>
                  <option value='male'>Masculino</option>
                  <option value='female'>Femenino</option>
                </select>
              </div>
            </div>

            <div className='form-row'>
              <div className='form-group col'>
                <DropdownList
                  name='reg_school_region'
                  placeholder='Región de tu establecimiento...'
                  data={regiones}
                  valueField='id'
                  textField='name'
                  filter='contains'
                  minLength={3}
                  onChange={(e) =>
                    this.handleChangeReg({
                      target: { name: 'reg_school_region', value: e.id },
                    })
                  }
                  onSearch={() => {
                    this.setState({ filtering: true });
                    setTimeout(() => this.setState({ filtering: false }), 1000);
                  }}
                  busy={this.state.filtering}
                />
              </div>
            </div>

            <div className='form-row'>
              <div className='form-group col'>
                <DropdownList
                  name='reg_school_comuna'
                  placeholder='Comuna de tu establecimiento...'
                  data={comunas.filter(
                    (c) => c.region_id === this.state.reg_school_region
                  )}
                  valueField='id'
                  textField='name'
                  filter='contains'
                  minLength={3}
                  onChange={(e) =>
                    this.handleChangeReg({
                      target: { name: 'reg_school_comuna', value: e.id },
                    })
                  }
                  onSearch={() => {
                    this.setState({ filtering: true });
                    setTimeout(() => this.setState({ filtering: false }), 1000);
                  }}
                  disabled={!this.state.reg_school_region.length}
                  busy={this.state.filtering}
                />
              </div>
            </div>

            <div className='form-row'>
              {/* <div className="form-group col">
                <select
                  className="form-control form-control"
                  name="reg_ciudad"
                  onChange={this.handleChangeReg}>
                  <option value="">¿En qué comuna está tu colegio?</option>
                </select>
              </div> */}
              <div className='form-group col'>
                <DropdownList
                  name='reg_school'
                  placeholder='Busca tu establecimiento...'
                  data={colegios.filter(
                    (c) =>
                      c.region_id === this.state.reg_school_region &&
                      c.comuna_id === this.state.reg_school_comuna &&
                      c.name &&
                      c.name.length > 0
                  )}
                  valueField='id'
                  textField='name'
                  filter='contains'
                  minLength={3}
                  onChange={(e) =>
                    this.handleChangeReg({
                      target: { name: 'reg_school', value: e.id },
                    })
                  }
                  onSearch={() => {
                    this.setState({ filtering: true });
                    setTimeout(() => this.setState({ filtering: false }), 1000);
                  }}
                  disabled={!this.state.reg_school_comuna.length}
                  busy={this.state.filtering}
                />
              </div>
            </div>

            <div className='form-row'>
              <div className='form-group col'>
                <select
                  className='form-control form-control'
                  name='reg_grade'
                  onChange={this.handleChangeReg}>
                  <option value=''>¿En qué curso estás?</option>
                  <option value='8'>1° Medio</option>
                  <option value='9'>2° Medio</option>
                  <option value='10'>3° Medio</option>
                  <option value='11'>4° Medio</option>
                  <option value='7'>Egresado</option>
                </select>
              </div>
            </div>

            <div className='form-row'>
              <div className='form-group col'>
                <select
                  className='form-control form-control'
                  name='reg_ciudad'
                  onChange={this.handleChangeReg}>
                  <option value=''>¿Dónde quieres estudiar?</option>
                  <option value='santiago'>Santiago</option>
                  <option value='temuco'>Temuco</option>
                </select>
              </div>
            </div>

            <div className='form-row'>
              <div className='form-group col'>
                <select
                  className='form-control form-control'
                  name='reg_carrera1'
                  disabled={carrerasOps.length > 0 ? false : true}
                  onChange={this.handleChangeReg}>
                  <option value=''>Carrera que deseas estudiar</option>
                  {carrerasOps}
                </select>
              </div>
            </div>

            {/* <div className='form-row'>
              <div className='form-group col'>
                <select
                  className='form-control form-control'
                  name='reg_carrera2'
                  disabled={carrerasOps.length > 0 ? false : true}
                  onChange={this.handleChangeReg}>
                  <option value=''>Preferencia 2</option>
                  {carrerasOps}
                </select>
              </div>
            </div> */}

            {/* <div className='form-row'>
              <div className='form-group col'>
                <select
                  className='form-control form-control'
                  name='reg_carrera3'
                  disabled={carrerasOps.length > 0 ? false : true}
                  onChange={this.handleChangeReg}>
                  <option value=''>Preferencia 3</option>
                  {carrerasOps}
                </select>
              </div>
            </div> */}

            <div className='form-row'>
              <div className='form-group col'>
                <input
                  className='form-control form-control'
                  name='reg_pass'
                  onChange={this.handleChangeReg}
                  type='password'
                  placeholder='Contraseña'
                />
              </div>
            </div>

            <div className='text-center'>
              <span
                className='btn btn-link padding-0'
                onClick={this.toggleModal}
                style={{
                  marginTop: '10px',
                  marginBottom: '10px',
                  color: '#000',
                }}>
                Revisar acá los Términos y Condiciones.
              </span>
              <div className='custom-control custom-checkbox mr-sm-2 d-inline-block text-left'>
                <input
                  type='checkbox'
                  className='custom-control-input'
                  name='reg_tyc'
                  id='tyc'
                  onChange={this.handleChangeReg}
                />
                <label className='custom-control-label' htmlFor='tyc'>
                  Acepto los Términos y Condiciones.
                </label>
              </div>
            </div>

            <button
              className='btn btn-lg btn-black margin-top-20 margin-bot-50'
              onClick={this.handleSubmitReg}>
              Registrar
            </button>

            {/* MODAL: Terms & Conditions */}
            <Modal
              title='Términos y Condiciones'
              show={this.state.modal}
              onClose={this.toggleModal}>
              <p>
                Al ingresar sus datos, enviará su información a la Universidad
                Mayor, para ser utilizada en la entrega de información sobre sus
                servicios. La información recopilada sólo es utilizada por la
                Universidad Mayor y no es transferida a otras empresas.
              </p>
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Login.jsx